var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass:
        "m-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light",
      attrs: { "data-dropdown-toggle": "click" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "m-dropdown__wrapper" }, [
        _c("span", {
          staticClass:
            "m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust arrow-user"
        }),
        _vm._v(" "),
        _c("div", { staticClass: "m-dropdown__inner" }, [
          _c(
            "div",
            {
              staticClass: "m-dropdown__header m--align-center",
              staticStyle: {
                background:
                  "url(assets/app/media/img/misc/user_profile_bg.jpg)",
                "background-size": "cover"
              }
            },
            [
              _c("div", { staticClass: "m-card-user m-card-user--skin-dark" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "m-card-user__details" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "m-card-user__name m--font-weight-500 font-small-user"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.fullName) +
                          "\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      staticClass:
                        "m-card-user__name m--font-weight-200 font-small-data",
                      attrs: { id: "nameCompanyProfile" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.company) +
                          "\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      staticClass:
                        "m-card-user__name m--font-weight-200 font-small-data",
                      attrs: { id: "nameProfileProfile" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.profile) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "m-dropdown__body" }, [
            _c("div", { staticClass: "m-dropdown__content" }, [
              _c("ul", { staticClass: "m-nav m-nav--skin-light" }, [
                _c("li", { staticClass: "m-nav__section m--hide" }, [
                  _c("span", { staticClass: "m-nav__section-text" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(_vm._f("capitalize")("section")) +
                        "\n                "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "m-nav__item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "m-nav__link",
                        attrs: {
                          id: "btn-user-dropdown",
                          to:
                            "/profile/" +
                            this.$store.state.authentication.user_data.id
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "m-nav__link-icon flaticon-profile-1"
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "m-nav__link-title" }, [
                          _c("span", { staticClass: "m-nav__link-wrap" }, [
                            _c("span", { staticClass: "m-nav__link-text" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm._f("capitalize")("my_profile")) +
                                  "\n                      "
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "m-nav__item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "m-nav__link",
                        attrs: { to: "/select-property" }
                      },
                      [
                        _c("i", {
                          staticClass: "m-nav__link-icon flaticon-logout"
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "m-nav__link-text" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm._f("capitalize")("change_profile")) +
                              "\n\t\t\t\t\t\t\t\t\t"
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", {
                  staticClass: "m-nav__separator m-nav__separator--fit"
                }),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "m-nav__item" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "m-nav__link", attrs: { to: "/faq" } },
                      [
                        _c("i", {
                          staticClass: "m-nav__link-icon flaticon-info"
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "m-nav__link-text" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm._f("capitalize")("faq")) +
                              "\n                  "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "m-nav__item" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "m-nav__link", attrs: { to: "/contact" } },
                      [
                        _c("i", {
                          staticClass: "m-nav__link-icon flaticon-lifebuoy"
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "m-nav__link-text" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm._f("capitalize")("contact")) +
                              "\n                  "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", {
                  staticClass: "m-nav__separator m-nav__separator--fit"
                }),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__item" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.logout()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t  " +
                          _vm._s(_vm._f("capitalize")("logout")) +
                          "\n\t\t\t\t\t\t\t\t"
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "m-nav__link m-dropdown__toggle",
        attrs: { id: "user-dropdown", href: "#" }
      },
      [
        _c("span", { staticClass: "m-nav__link-icon" }, [
          _c("span", { staticClass: "m-nav__link-icon-wrapper" }, [
            _c("i", { staticClass: "flaticon-user-ok notification-i" })
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-card-user__pic" }, [
      _c("img", {
        staticClass: "m--img-rounded m--marginless",
        attrs: { src: "/media/img/logo_m.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb312912", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb312912","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/navbar/Profile.vue
// module id = 563
// module chunks = 0 54 132 156